module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/files/files.component.css
// module id = ./src/app/files/files.component.css
// module chunks = main